import React, { useState, useEffect } from "react";
import URL_API from '../variaveis_globais/const';
import VariaveisGlobais from "variaveis_globais/variaveis_globais";
import { Badge, Button, Card, Container, Row, Col, Spinner, Alert, Modal } from "react-bootstrap";
import socketIOClient from "socket.io-client";
import { inicializarInstancia, deslogarInstancia, estaConectado, qrCodeInstancia, buscarHistoricoInstancia } from "data/api/gsConnectApi";
import { useHistory } from 'react-router-dom';

const socket = socketIOClient(URL_API);

const InstanciaWhatsapp = ({ numeroInstancia, onStatusChange }) => {
  const [qrCode, setQrCode] = useState("");
  const [logado, setLogado] = useState(false);
  const [carregandoQrCode, setCarregandoQrCode] = useState(false);
  const [nomeInstancia, setNomeInstancia] = useState('');
  const [erro, setErro] = useState('');
  const [showHistorico, setShowHistorico] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);

  useEffect(() => {
    verificarConexao();
  }, []);

  const verificarConexao = async () => {
    try {
      const data = await estaConectado(numeroInstancia);
      if (data.error) {
        setErro(data.message);
        return;
      }

      
      if (data && data.message && data.message.phone_connected) {
        setLogado(true);
        setCarregandoQrCode(false);
        setQrCode('');
        setNomeInstancia(data.message.user.name ?? '');
        onStatusChange && onStatusChange(numeroInstancia, true);
      } else {
        onStatusChange && onStatusChange(numeroInstancia, false);
      }
    } catch (erro) {
      console.error('Erro ao verificar conexão:', erro);
      setErro('Erro ao verificar conexão');
      onStatusChange && onStatusChange(numeroInstancia, false);
    }
  };

  const aguardarQrCode = async () => {
    let tentativas = 0;
    const maxTentativas = 60; // 5 minutos máximo
    
    while (tentativas < maxTentativas) {
      try {
        const qrCodeResult = await qrCodeInstancia(numeroInstancia);

        const estaConectadoResultado = await estaConectado(numeroInstancia);
        console.log(estaConectadoResultado);
        if (estaConectadoResultado && estaConectadoResultado.message && estaConectadoResultado.message.phone_connected) {
          setLogado(true);
          setCarregandoQrCode(false);
          setQrCode('');
          setNomeInstancia(estaConectadoResultado.message.user.name ?? '');
          onStatusChange && onStatusChange(numeroInstancia, true);
          break;
        }

        
        // novo

        if (estaConectadoResultado.message && estaConectadoResultado.message.qrcode) {
          setCarregandoQrCode(false);
          setQrCode(estaConectadoResultado.message.qrcode);
        } 
        
        await delay(5000);
        tentativas++;
      } catch (error) {
        console.error('Erro ao aguardar QR Code:', error);
        //setErro('Erro ao gerar QR Code');
        setCarregandoQrCode(false);
        break;
      }
    }
    
    if (tentativas >= maxTentativas) {
      setCarregandoQrCode(false);
      setErro('Timeout ao aguardar conexão');
    }
  };

  const inicializar = async () => {
    setErro('');
    setCarregandoQrCode(true);
    
    try {
      const data = await inicializarInstancia(numeroInstancia);
      if (data.message === "Instancia já iniciada." || data.message === "" || data.message === "Instância iniciada com sucesso.") {
        aguardarQrCode();
      }
    } catch (error) {
      console.error('Erro ao inicializar instância:', error);
      setErro('Erro ao inicializar instância');
      setCarregandoQrCode(false);
    }
  };

  const deslogar = async () => {
    try {
      await deslogarInstancia(numeroInstancia);
      setQrCode('');
      setLogado(false);
      setNomeInstancia('');
      setErro('');
      onStatusChange && onStatusChange(numeroInstancia, false);
    } catch (error) {
      console.error('Erro ao deslogar:', error);
      setErro('Erro ao desconectar');
    }
  };

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const carregarHistorico = async () => {
    setLoadingHistorico(true);
    try {
      const response = await buscarHistoricoInstancia(numeroInstancia);
      setHistorico(response.data || []);
      setShowHistorico(true);
    } catch (error) {
      console.error('Erro ao carregar histórico:', error);
      setErro('Erro ao carregar histórico');
    } finally {
      setLoadingHistorico(false);
    }
  };

  const getStatusColor = () => {
    if (logado) return '#198754';
    if (carregandoQrCode) return '#ff9800';
    return '#757575';
  };

  const getStatusText = () => {
    if (logado) return 'Conectado';
    if (carregandoQrCode) return 'Conectando...';
    return 'Desconectado';
  };

  return (
    <div className="bg-white mb-3" style={{border: '1px solid #dee2e6'}}>
      <div style={{backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6'}}>
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0" style={{color: '#495057', fontWeight: '600'}}>
            📱 WhatsApp {numeroInstancia}
            {nomeInstancia && <span style={{color: '#6c757d', fontWeight: '400'}}> - {nomeInstancia}</span>}
          </h6>
          <Badge 
            style={{backgroundColor: getStatusColor(), color: 'white'}}
            className="px-2 py-1"
          >
            {getStatusText()}
          </Badge>
        </div>
      </div>
      
      <div className="p-3">
        {erro && (
          <Alert variant="danger" className="mb-3" dismissible onClose={() => setErro('')}>
            ⚠️ {erro}
          </Alert>
        )}

        <div className="d-flex justify-content-center align-items-center" style={{minHeight: '300px'}}>
          {carregandoQrCode && (
            <div className="text-center">
              <Spinner animation="border" style={{color: '#198754', marginBottom: '16px'}} />
              <div style={{fontSize: '14px', color: '#6c757d'}}>
                Gerando QR Code...
                <br />
                <small>Aguarde alguns segundos</small>
              </div>
            </div>
          )}

          {!carregandoQrCode && qrCode && (
            <div className="text-center">
              <div style={{
                padding: '16px',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                marginBottom: '16px'
              }}>
                <img 
                  src={qrCode} 
                  alt={`QR Code WhatsApp ${numeroInstancia}`}
                  style={{height: '250px', width: '250px', borderRadius: '8px'}}
                />
              </div>
              <div style={{fontSize: '13px', color: '#6c757d', lineHeight: '1.4'}}>
                <strong>📱 Escaneie com seu WhatsApp:</strong>
                <br />
                WhatsApp → Dispositivos vinculados → Vincular dispositivo
              </div>
            </div>
          )}

          {!carregandoQrCode && !qrCode && !logado && (
            <div className="text-center">
              <div style={{fontSize: '3rem', marginBottom: '16px', opacity: '0.3'}}>📱</div>
              <h6 style={{color: '#495057', marginBottom: '12px'}}>WhatsApp Desconectado</h6>
              <p style={{fontSize: '13px', color: '#6c757d', marginBottom: '20px'}}>
                Clique no botão abaixo para gerar o QR Code e conectar sua conta do WhatsApp
              </p>
              <div>
                <Button
                  variant="success"
                  onClick={inicializar}
                  style={{
                    backgroundColor: '#198754',
                    borderColor: '#198754',
                    fontSize: '13px',
                    padding: '8px 24px',
                    color: '#FFFFFF',
                    marginRight: '8px'
                  }}
                >
                  🔗 Gerar QR Code
                </Button>
                <Button
                  variant="outline-info"
                  size="sm"
                  onClick={carregarHistorico}
                  disabled={loadingHistorico}
                  style={{fontSize: '12px', padding: '6px 16px'}}
                >
                  {loadingHistorico ? 'Carregando...' : '📋 Histórico de conexões'}
                </Button>
              </div>
            </div>
          )}

          {!carregandoQrCode && logado && (
            <div className="text-center">
              <div style={{fontSize: '3rem', marginBottom: '16px', color: '#198754'}}>✅</div>
              <h6 style={{color: '#198754', marginBottom: '8px'}}>Conectado com Sucesso!</h6>
              <p style={{fontSize: '13px', color: '#6c757d', marginBottom: '20px'}}>
                {nomeInstancia && `Conta: ${nomeInstancia}`}
                <br />
                Sua instância está pronta para enviar mensagens
              </p>
              <div>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={deslogar}
                  style={{fontSize: '12px', padding: '6px 16px', marginRight: '8px'}}
                >
                  🔌 Desconectar
                </Button>
                <Button
                  variant="outline-info"
                  size="sm"
                  onClick={carregarHistorico}
                  disabled={loadingHistorico}
                  style={{fontSize: '12px', padding: '6px 16px'}}
                >
                  {loadingHistorico ? 'Carregando...' : '📋 Histórico de conexões'}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal de Histórico */}
      <Modal show={showHistorico} onHide={() => setShowHistorico(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Histórico de Conexões - WhatsApp {numeroInstancia}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{maxHeight: '500px', overflowY: 'auto'}}>
          {historico.length === 0 ? (
            <p className="text-center text-muted">Nenhum histórico encontrado</p>
          ) : (
            historico.map((item, index) => (
              <div key={index} style={{
                borderBottom: index < historico.length - 1 ? '1px solid #dee2e6' : 'none', 
                padding: '12px', 
                marginBottom: '8px',
                backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white'
              }}>
                <div style={{marginBottom: '8px'}}>
                  <strong style={{color: '#495057'}}>
                    📅 {new Date(item.dataMudanca).toLocaleString('pt-BR')}
                  </strong>
                </div>
                <div style={{fontSize: '14px', marginBottom: '4px'}}>
                  <span style={{color: '#6c757d'}}>Status:</span>{' '}
                  <span style={{fontWeight: '500'}}>{item.statusAnterior}</span>
                  {' → '}
                  <span style={{fontWeight: '500'}}>{item.statusNovo}</span>
                </div>
                <div style={{fontSize: '14px', marginBottom: '4px'}}>
                  <span style={{color: '#6c757d'}}>Conexão:</span>{' '}
                  <span style={{
                    color: item.conectadaAnterior ? '#198754' : '#dc3545',
                    fontWeight: '500'
                  }}>
                    {item.conectadaAnterior ? 'Conectada' : 'Desconectada'}
                  </span>
                  {' → '}
                  <span style={{
                    color: item.conectadaNova ? '#198754' : '#dc3545',
                    fontWeight: '500'
                  }}>
                    {item.conectadaNova ? 'Conectada' : 'Desconectada'}
                  </span>
                </div>
                <div style={{
                  color: '#6c757d', 
                  fontSize: '13px', 
                  marginTop: '8px',
                  padding: '8px',
                  backgroundColor: 'white',
                  borderLeft: '3px solid #007bff',
                  borderRadius: '4px'
                }}>
                  💡 {item.motivo}
                </div>
              </div>
            ))
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowHistorico(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

function ConfiguracoesWhatsAppView() {
  const [statusInstancias, setStatusInstancias] = useState({});
  const [mensagemSucesso, setMensagemSucesso] = useState('');
  const history = useHistory();

  const handleStatusChange = (numeroInstancia, conectado) => {
    setStatusInstancias(prev => ({
      ...prev,
      [numeroInstancia]: conectado
    }));

    if (conectado) {
      setMensagemSucesso(`WhatsApp ${numeroInstancia} conectado com sucesso!`);
      setTimeout(() => setMensagemSucesso(''), 3000);
    }
  };

  const instanciasConectadas = Object.values(statusInstancias).filter(Boolean).length;
  const totalInstancias = 4;

  const statCards = [
    { value: instanciasConectadas, label: 'Instâncias Conectadas', icon: '📱', color: '#198754' },
    { value: totalInstancias - instanciasConectadas, label: 'Desconectadas', icon: '📵', color: '#757575' },
    { value: '24/7', label: 'Monitoramento', icon: '🔄', color: '#2e7d32' },
    { value: 'Estável', label: 'Status Geral', icon: '✅', color: '#388e3c' }
  ];

  return (
    <div style={{backgroundColor: '#f8f9fa', minHeight: '100vh'}}>
      {/* Header seguindo padrão */}
      <div style={{backgroundColor: '#198754', color: 'white', padding: '12px 20px', fontSize: '16px', fontWeight: '500'}}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Button variant="outline-light" size="sm" style={{borderColor: 'white', color: 'white', marginRight: 12}} onClick={() => history.push('/admin/home')}>
              ← Voltar
            </Button>
            <span>Configurações WhatsApp</span>
          </div>
          <Badge bg="primary" className="px-3 py-2">
            {instanciasConectadas}/{totalInstancias} conectadas
          </Badge>
        </div>
      </div>

      <Container fluid className="p-3">
        {/* Alert de sucesso */}
        {mensagemSucesso && (
          <Alert variant="success" className="mb-3" dismissible onClose={() => setMensagemSucesso('')}>
            ✅ {mensagemSucesso}
          </Alert>
        )}

        {/* Cards de Estatísticas */}
        <Row className="mb-3">
          {statCards.map((stat, index) => (
            <Col xl={3} lg={4} md={6} key={index} className="mb-3">
              <Card className="text-center h-100" style={{backgroundColor: stat.color, color: 'white'}}>
                <Card.Body className="py-3">
                  <div style={{fontSize: '2rem', marginBottom: '8px'}}>{stat.icon}</div>
                  <h4 className="mb-1">{stat.value}</h4>
                  <small>{stat.label}</small>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Card de Instruções */}
        <div className="bg-white p-3 mb-3" style={{border: '1px solid #dee2e6'}}>
          <h6 className="mb-3" style={{color: '#198754', fontWeight: '600'}}>📋 Como conectar seu WhatsApp</h6>
          <Row>
            <Col md={6}>
              <div className="d-flex mb-2">
                <span style={{color: '#198754', fontWeight: '600', marginRight: '8px'}}>1.</span>
                <span style={{fontSize: '13px', color: '#495057'}}>Clique em "Gerar QR Code" na instância desejada</span>
              </div>
              <div className="d-flex mb-2">
                <span style={{color: '#198754', fontWeight: '600', marginRight: '8px'}}>2.</span>
                <span style={{fontSize: '13px', color: '#495057'}}>Abra o WhatsApp no seu celular</span>
              </div>
            </Col>
            <Col md={6}>
              <div className="d-flex mb-2">
                <span style={{color: '#43a047', fontWeight: '600', marginRight: '8px'}}>3.</span>
                <span style={{fontSize: '13px', color: '#495057'}}>Vá em "Dispositivos vinculados" no menu</span>
              </div>
              <div className="d-flex mb-2">
                <span style={{color: '#43a047', fontWeight: '600', marginRight: '8px'}}>4.</span>
                <span style={{fontSize: '13px', color: '#495057'}}>Toque em "Vincular dispositivo" e escaneie o QR Code</span>
              </div>
            </Col>
          </Row>
        </div>

        {/* Instâncias WhatsApp */}
        <Row>
          {[1, 2].map(numero => (
            <Col md={6} key={numero} className="mb-3">
              <InstanciaWhatsapp 
                numeroInstancia={numero} 
                onStatusChange={handleStatusChange}
              />
            </Col>
          ))}
        </Row>

        <Row>
          {[3, 4].map(numero => (
            <Col md={6} key={numero} className="mb-3">
              <InstanciaWhatsapp 
                numeroInstancia={numero} 
                onStatusChange={handleStatusChange}
              />
            </Col>
          ))}
        </Row>

        {/* Card de Dicas */}
        <div className="bg-white p-3" style={{border: '1px solid #dee2e6'}}>
          <h6 className="mb-3" style={{color: '#43a047', fontWeight: '600'}}>💡 Dicas importantes</h6>
          <Row>
            <Col md={6}>
              <ul style={{fontSize: '13px', color: '#6c757d', paddingLeft: '20px'}}>
                <li>Mantenha seu celular conectado à internet</li>
                <li>Não desconecte dispositivos vinculados pelo celular</li>
              </ul>
            </Col>
            <Col md={6}>
              <ul style={{fontSize: '13px', color: '#6c757d', paddingLeft: '20px'}}>
                <li>Use instâncias diferentes para tipos de mensagem distintos</li>
                <li>Monitore o status regularmente</li>
              </ul>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default ConfiguracoesWhatsAppView;